

import React from "react";
import styled from "styled-components";
import { useWeb3Modal, useWeb3ModalAccount } from "@web3modal/ethers/react";
import "react-toastify/dist/ReactToastify.css";

// Styled components
const NavbarWrapper = styled.header`
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;

  @media (max-width: 768px) {
    display: none; /* Hide on mobile */
  }
`;

const Button = styled.button`
  background-color: black;
  color: white;
  border-radius: 5px;
  padding: 10px 15px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #6a11cb;
  }
`;

const CurrencySelect = styled.select`
  background-color: #000;
  color: white;
  border: 1px solid #fff;
  padding: 5px;
  border-radius: 5px;
`;

const Navbar = () => {
  const { open } = useWeb3Modal();
  const { isConnected, address } = useWeb3ModalAccount();

  const handleButtonClick = () => {
    try {
      open(isConnected ? "Account" : "Connect");
    } catch (error) {
      console.error("Failed to open Web3Modal:", error);
    }
  };


  // Function to switch networks using Web3Modal
  const switchNetwork = async (network) => {
    try {
      if (!isConnected) {
        open("Connect"); // Open Web3Modal to connect wallet if not connected
        return;
      }

      if (window.ethereum) {
        let networkParams;

        // Prepare network details for BSC and Polygon
        if (network === "bnb") {
          networkParams = {
            chainId: "0x38", // BSC mainnet chain ID in hex (56 in decimal)
            chainName: "Binance Smart Chain",
            rpcUrls: ["https://bsc-dataseed.binance.org/"],
            nativeCurrency: {
              name: "BNB",
              symbol: "BNB",
              decimals: 18,
            },
            blockExplorerUrls: ["https://bscscan.com"],
          };
        } else if (network === "polygon") {
          networkParams = {
            chainId: "0x89", // Polygon mainnet chain ID in hex (137 in decimal)
            chainName: "Polygon",
            rpcUrls: ["https://rpc-mainnet.maticvigil.com/"],
            nativeCurrency: {
              name: "MATIC",
              symbol: "MATIC",
              decimals: 18,
            },
            blockExplorerUrls: ["https://polygonscan.com"],
          };
        }

        // Request to switch the network using wallet_switchEthereumChain
        try {
          await window.ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: networkParams.chainId }], // Switch to the selected network
          });
        } catch (error) {
          // If the network is not added to the wallet, we add it using wallet_addEthereumChain
          if (error.code === 4902) {
            await window.ethereum.request({
              method: "wallet_addEthereumChain",
              params: [networkParams], // Add the network if it's not available
            });
          }
        }
      }
    } catch (error) {
      console.error("Failed to switch network:", error);
    }
  };


  return (
    <NavbarWrapper>
      {/* Left side can stay empty if no logo is needed */}
      <div></div>

      {/* Right side for desktop */}
      <ButtonWrapper>
      <Button onClick={() => switchNetwork("bnb")}>Switch to BNB (BSC)</Button>
        <Button onClick={() => switchNetwork("polygon")}>Switch to Polygon</Button>

        <Button onClick={handleButtonClick} className="border bg-[black] text-white rounded-md px-4 py-2 hover:bg-[#6a11cb] hover:text-white transition">
          {isConnected
            ? `${address.substring(0, 4)}...${address.substring(
                address.length - 4
              )}`
            : "CONNECT WALLET"}
        </Button>
      </ButtonWrapper>
    </NavbarWrapper>
  );
};

export default Navbar;

